/**
 * Justesims country picker — accessible tabs (Popular / Country / Region).
 * Click + arrow-key navigation, scoped per section instance.
 */
(function () {
  function initPicker(root) {
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) return;

    function activate(tab, setFocus) {
      tabs.forEach((t) => {
        const selected = t === tab;
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        t.tabIndex = selected ? 0 : -1;
      });
      const targetId = tab.getAttribute('aria-controls');
      panels.forEach((p) => {
        p.hidden = p.id !== targetId;
      });
      if (setFocus) tab.focus();
    }

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(tab, false));
      tab.addEventListener('keydown', (e) => {
        let idx = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') idx = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') idx = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') idx = 0;
        else if (e.key === 'End') idx = tabs.length - 1;
        if (idx !== null) {
          e.preventDefault();
          activate(tabs[idx], true);
        }
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('.je-cp').forEach((root) => {
      initPicker(root);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', () => init());

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
